import styled from 'styled-components';

export const TabPanel = styled.div`
  overflow: auto;
`;
